import { render, staticRenderFns } from "./PwView.vue?vue&type=template&id=0c09d08c&scoped=true&"
import script from "./PwView.vue?vue&type=script&lang=js&"
export * from "./PwView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c09d08c",
  null
  
)

export default component.exports